<script setup lang="ts">
import type Housing from '~/models/Housing';

defineProps({
  housing: {
    type: Object as PropType<Housing>,
    required: true,
  },
});

const { t } = useI18n({
  useScope: 'local',
});
</script>

<template>
  <h1>{{ t('title') }}</h1>
  <p>{{ t('text') }}</p>
  <div class="button-container">
    <tw-ui-action is="link" variant="button-primary" :to="{ name: 'housing-edit' }">
      {{ t('link-text') }}
    </tw-ui-action>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/tw-mixins.scss';

h1 {
  margin: 0;
  line-height: 1.2;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;

  @include tw-is-desktop {
    margin: 0 1rem 2rem;
    font-size: 2.25rem;
  }
}

p {
  text-align: center;
  margin-bottom: 2rem;
}

.button-container {
  text-align: center;
}
</style>

<i18n lang="json">
{
  "de": {
    "title": "Nur noch 1 Schritt zu mehr Reichweite durch die Multi-Portal Veröffentlichung.",
    "text": "Um die Multi-Portal Veröffentlichung durchführen zu können, benötigt deine Anzeige mindestens ein Foto und eine Beschreibung von mindestens 150 Zeichen.",
    "link-text": "Meine Anzeige bearbeiten"
  },
  "en": {
    "title": "Only 1 more step to more reach through multi-platform publishing.",
    "text": "To execute the multi-portal publication, your ad needs at least one photo and a description of at least 150 characters.",
    "link-text": "Edit my ad"
  }
}
</i18n>
